export function updateMarketplaceOffers(newOfferId: string, json: any) {
  function traverseElements(elements: any) {
    if (!Array.isArray(elements)) return;
    elements.forEach((element: any) => {
      if (element.tracking) {
        if (Array.isArray(element.tracking)) {
          const marketplaceOfferObj = element.tracking.find(
            (item: any) =>
              item && typeof item === 'object' && 'marketplaceOfferId' in item
          );
          if (marketplaceOfferObj) {
            marketplaceOfferObj.marketplaceOfferId = newOfferId;
          }
        }
      }
      // If components exist in the element, update marketplaceOfferId
      if (Array.isArray(element.components)) {
        element.components.forEach((component: any) => {
          if ('marketplaceOfferId' in component) {
            component.marketplaceOfferId = newOfferId;
          }

          // If marketplaceOfferId exists inside dynamicTextOptions
          if (
            component.dynamicTextOptions &&
            typeof component.dynamicTextOptions === 'object' &&
            'marketplaceOfferId' in component.dynamicTextOptions
          ) {
            component.dynamicTextOptions.marketplaceOfferId = newOfferId;
          }
          // If marketplaceOfferId exists inside ctaSubtext
          if (
            component.ctaSubtext &&
            typeof component.ctaSubtext === 'object' &&
            'marketplaceOfferId' in component.ctaSubtext
          ) {
            component.ctaSubtext.marketplaceOfferId = newOfferId;
          }
          // If marketplaceOfferId exists inside ctaExtraText
          if (
            component.ctaExtraText &&
            typeof component.ctaExtraText === 'object' &&
            'marketplaceOfferId' in component.ctaExtraText
          ) {
            component.ctaExtraText.marketplaceOfferId = newOfferId;
          }
          // If marketplaceOfferId exists inside label
          if (
            component.label &&
            typeof component.label === 'object' &&
            'marketplaceOfferId' in component.label
          ) {
            component.label.marketplaceOfferId = newOfferId;
          }
          // If marketplaceOfferId exists inside content
          if (
            component.content &&
            typeof component.content === 'object' &&
            'marketplaceOfferId' in component.content
          ) {
            component.content.marketplaceOfferId = newOfferId;
          }
          // If marketplaceOfferId exists inside body
          if (
            component.body &&
            typeof component.body === 'object' &&
            'marketplaceOfferId' in component.body
          ) {
            component.body.marketplaceOfferId = newOfferId;
          }
          // If marketplaceOfferId exists inside bodyBulletList
          if (
            component.bodyBulletList &&
            typeof component.bodyBulletList === 'object' &&
            'marketplaceOfferId' in component.bodyBulletList
          ) {
            component.bodyBulletList.marketplaceOfferId = newOfferId;
          }
          if (
            component.bodyBulletList &&
            typeof component.bodyBulletList === 'object' &&
            'marketplaceOfferId' in component.bodyBulletList
          ) {
            component.bodyBulletList.marketplaceOfferId = newOfferId;
          }
          // If component is a bulletList with items array
          if (
            component.componentType === 'bulletList' &&
            component.items &&
            Array.isArray(component.items)
          ) {
            component.items.forEach((item: any) => {
              if (
                item &&
                typeof item === 'object' &&
                'marketplaceOfferId' in item
              ) {
                item.marketplaceOfferId = newOfferId;
              }
            });
          }
          // If component is a Accordion
          if (
            component.componentType === 'accordion' &&
            component.sections &&
            Array.isArray(component.sections)
          ) {
            component.sections.forEach((section: any) => {
              // If marketplaceOfferId exists inside body
              if (
                section.body &&
                typeof section.body === 'object' &&
                'marketplaceOfferId' in section.body
              ) {
                section.body.marketplaceOfferId = newOfferId;
              }
              // If marketplaceOfferId exists inside bodyBulletList
              if (
                section.bodyBulletList &&
                typeof section.bodyBulletList === 'object' &&
                'marketplaceOfferId' in section.bodyBulletList
              ) {
                section.bodyBulletList.marketplaceOfferId = newOfferId;
              }
            });
          }
        });
      }

      // Recursively traverse nested elements
      if (Array.isArray(element.elements)) {
        traverseElements(element.elements);
      }
    });
  }

  // Clone to avoid mutation (optional – remove if mutation is acceptable)
  const updated = structuredClone(json);

  // Start traversal from the root props.elements
  if (
    updated &&
    typeof updated === 'object' &&
    updated.props &&
    Array.isArray(updated.props.elements)
  ) {
    traverseElements(updated.props.elements);
  }

  return updated;
}
